import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationStrategy, Location } from '@angular/common';
@Component({
  selector: 'multiple-user-list',
  templateUrl: './multiple-user-list.component.html',
  styleUrls: ['./multiple-user-list.component.scss']
})
export class MultipleUserListComponent implements OnInit {

  selectedTab
  currentView = 'staff'
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private locationStrategy: LocationStrategy
  ) { }

  ngOnInit() {
    console.log("Selected tab: ", this.selectedTab)
    this.route.queryParams.subscribe(params => {
      console.log("Query params multiple user list: ", params);
      if (params.currentTab) {
        this.selectedTab = params.currentTab
      }
      else {
        this.selectedTab = 0
        this.updateQueryParams({ currentTab: this.selectedTab })
      }
    })
  }

  tabChanged(event) {
    console.log("tab changed event: ", event);
    this.selectedTab = event.index
    if (this.selectedTab === 2) {
      this.currentView = 'pendingStaff'
    }
    if (this.selectedTab === 0) {
      this.currentView = 'staff'
    }
    this.updateQueryParams({ currentTab: this.selectedTab })
  }

  updateQueryParams(obj) {
    console.log("update query params: ", obj)
    this._location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        {
          relativeTo: this.route, queryParams: obj
        },
      ).toString()
    );
    console.log("updated url: ", this.locationStrategy.path())
  }

}
